import ModalWindow from "./ModalWindow";
export * from "./ModalWindow";

export default ModalWindow;
